import { render, staticRenderFns } from "./LiquorDetailHeader.vue?vue&type=template&id=a8f954d6&"
import script from "./LiquorDetailHeader.vue?vue&type=script&lang=js&"
export * from "./LiquorDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./LiquorDetailHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports